import React from "react";
import SweetAlert from 'react-bootstrap-sweetalert';

export default (props) => {
  const {
    inputProps,
    onConfirm,
    onCancel
  } = props;
  const { type, show, title, text, user } = inputProps;

  return (
    <SweetAlert
      style={{overflow:'unset'}}
      type={type}
      confirmBtnCssClass="alert-btn-confirm"
      cancelBtnCssClass="alert-btn-cancel"
      showCancel
      showConfirm
      show={show}
      confirmBtnText={type === "success" ? "Готово" : "Продолжить"}
      cancelBtnText="Отменить"
      confirmBtnBsStyle="danger"
      cancelBtnBsStyle="default"
      title={title}
      onConfirm={type === "success" ? () => onCancel() : () => onConfirm()}
      onCancel={onCancel}
    >
      <div>
        <span>
          {text.replace('{user}', user.first_name + ' ' + user.last_name)}
        </span>
      </div>
    </SweetAlert>
  )
}


// WEBPACK FOOTER //
// ./src/components/Account/BlackListModal.js